module.exports = __webpack_public_path__ + "159a30eaaa7f7743ed87fb986cc9f27c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Tutors/images/img_tutor_step01.svg
// module id = 1605
// module chunks = 8